import { defaultCss } from "survey-core";

export var presetsCss = {
  root: "sps-root-modern",
  rootTheme: "",
  container: "sps-container-modern",
  header: "sps-title sps-container-modern__title",
  body: "sps-body",
  bodyEmpty: "sps-body sps-body--empty",
  footer: "sps-footer sps-body__footer sps-clearfix",
  title: "",
  description: "",
  logo: "sps-logo",
  logoImage: "sps-logo__image",
  headerText: "sps-header__text",
  navigationButton: "",
  bodyNavigationButton: "",
  completedPage: "sps-completedpage",
  panel: {
    withFrame: "sps-panel--with-frame",
    nested: "sps-panel--nested",
    expandableAnimating: "",
    header: "sps-panel__header",
    title: "sps-title sps-panel__title",
    titleBar: "sd-action-title-bar sps-action-title-bar",
    contentEnter: "sps-panel__content--enter",
    contentLeave: "sps-panel__content--leave",
    titleExpandable: "sps-panel__title--expandable",
    titleExpanded: "sps-panel__title--expanded",
    titleCollapsed: "sps-panel__title--collapsed",
    titleOnError: "sps-panel__title--error",
    description: "sps-description sps-panel__description",
    container: "sps-panel sps-row__panel",
    content: "sps-panel__content",
    icon: "sps-panel__icon",
    iconExpanded: "sps-panel__icon--expanded",
    footer: "sps-panel__footer",
    requiredMark: "sps-panel__required-text",
    collapsed: "sps-panel--collapsed",
    expanded: "sps-panel--expanded",
  },
  paneldynamic: {
    nested: "",
    mainRoot: "sps-question sps-row__question",
    root: "sps-paneldynamic",
    navigation: "sps-paneldynamic__navigation",
    title: "sps-title sps-question__title",
    buttonAdd: "sps-paneldynamic__add-btn",
    panelsContainer: "",
    panelWrapper: "sps-paneldynamic__panel-wrapper",
    panelWrapperList: "",
    progressTop: "sps-paneldynamic__progress sps-paneldynamic__progress--top",
    progressBottom:
      "sps-paneldynamic__progress sps-paneldynamic__progress--bottom",
    buttonPrev: "sps-paneldynamic__prev-btn",
    buttonNext: "sps-paneldynamic__next-btn",
    progressContainer: "sps-paneldynamic__progress-container",
    progress: "sps-progress",
    progressBar: "sps-progress__bar",
    progressText: "sps-paneldynamic__progress-text",
    panelFooter: "sps-panel__footer",
    separator: "sps-paneldynamic__separator",
    footer: "sps-paneldynamic__footer",
    footerButtonsContainer: "sps-paneldynamic__buttons-container",
  },
  progress: "sps-progress sps-body__progress",
  progressBar: "sps-progress__bar",
  progressText: "sps-progress__text",
  progressTextInBar: "sps-hidden",
  page: {
    root: "sps-page sps-body__page",
    title: "sps-title sps-page__title",
    description: "sps-description sps-page__description"
  },
  pageTitle: "sps-title sps-page__title",
  pageDescription: "sps-description sps-page__description",
  row: "sps-row sps-clearfix",
  rowEnter: "sps-row--enter",
  rowLeave: "sps-row--leave",
  rowDelayedEnter: "sps-row--delayed-fade-in",
  rowMultiple: "sps-row--multiple",
  question: {
    withFrame: "sps-question--with-frame",
    nested: "sps-question--nested",
    mainRoot: "sps-question sps-row__question",
    flowRoot: "sps-question sps-row__question sps-row__question--flow",
    asCell: "sps-table__cell",
    header: "sps-question__header",
    headerLeft: "sps-question__header--location--left",
    headerTop: "sps-question__header--location--top",
    headerBottom: "sps-question__header--location--bottom",
    content: "sps-question__content",
    contentLeft: "sps-question__content--left",
    titleLeftRoot: "sps-question--location--left",
    titleOnAnswer: "sps-question__title--answer",
    titleOnError: "sps-question__title--error",
    title: "sps-title sps-question__title",
    titleBar: "sd-action-title-bar sps-action-title-bar",
    requiredMark: "sps-question__required-text",
    number: "sps-question__num",
    description: "sps-description sps-question__description",
    descriptionUnderInput: "sps-question__description--under",
    comment: "sps-comment",
    required: "sps-question--required",
    titleRequired: "sps-question__title--required",
    indent: 0,
    footer: "sps-question__footer",
    formGroup: "sps-question__form-group",
    hasError: "",
    readOnly: "sd-question--readonly sps-question--disabled",
    confirmDialog: "sps-popup--confirm sv-popup--confirm svc-creator-popup",
    errorsContainerBottom: "sps-question__erbox--below-question",
  },
  checkbox: {
    ...defaultCss.checkbox,
    root: defaultCss.checkbox.root + " sps-selectbase",
  },
  boolean: {
    ...defaultCss.boolean,
    rootCheckbox: defaultCss.boolean.rootCheckbox + " sps-selectbase",
  },
  dropdown: {
    ...defaultCss.dropdown,
    content: "sps-question__content sps-question__content--dropdown",
  },
  matrixdynamic: {
    mainRoot: "sps-question sps-question--matrixdynamic sd-element sd-question sd-row__question sd-element--complex sd-question--complex",
    tableWrapper: "sps-table-wrapper",
    root: "sps-table sps-matrixdynamic",
    header: "sps-question__header",
    content: "sps-matrixdynamic__content sps-text__content",
    cell: "sps-table__cell",
    row: "sps-table__row",
    rowDisabled: "sps-table__row-disabled",
    rowReadOnly: "sps-table__row-readonly",
    headerCell: "sps-table__cell sps-table__cell--header",
    detailRow: "sps-table__row sps-table__row--detail",
    detailButton: "sps-table__cell--detail-button",
    detailButtonExpanded: "sps-table__cell--detail-button--expanded",
    detailIcon: "sps-detail-panel__icon",
    detailIconExpanded: "sps-detail-panel__icon--expanded",
    detailIconExpandedId: "icon-collapse-24x24",
    detailIconId: "icon-expand-24x24",
    detailPanelCell: "sps-table__cell sps-table__cell--detail-panel",
    expandedRow: "sps-table__row--expanded sd-table__row--expanded",
    actionsCell: "sps-table__cell sps-table__cell--actions",
    buttonAdd: "sps-matrixdynamic__add-btn",
    buttonRemove: "",
    iconAdd: "",
    iconRemove: "#icon-delete-24x24",
    dragElementDecorator: "sps-drag-element__svg",
    iconDragElement: "icon-drag-24x24",
    iconDrag: "sps-matrixdynamic__drag-element",
    toolbar: "sps-matrixdynamic__footer",
    toolbarTop: "",
    toolbarBottom: "",
    dragDropGhostPositionTop: "sps-matrixdynamic__drag-drop-ghost-position-top",
    dragDropGhostPositionBottom: "sps-matrixdynamic__drag-drop-ghost-position-bottom",
    noRowsSection: "sps-matrixdynamic__placeholder",
    noRowsText: "sps-matrixdynamic__placeholder-text",
    cellQuestionWrapper: "sps-table__question-wrapper",
    draggedRow: "sps-matrixdynamic__dragged-row",
    emptyCell: "sps-table__cell--empty",
    rowEmpty: "sps-table__row--empty",
    rowEnter: "sps-table__row--enter",
    rowLeave: "sps-table__row--leave",
  },
};
